._FontControls_hj7og_1 {
  display: flex;
  align-items: center;
  gap: 8px;
}

._fontSelect_hj7og_7 {
  min-width: 120px;
}

._sizeSelect_hj7og_11 {
  min-width: 60px;
}